import sizes from "@/lib/utils/sizes";
import {
  CollectionListingPageStoryblok,
  CollectionPageStoryblok,
  MediaStoryblok,
  TaggedImageStoryblok
} from "@/types/blok-types";
import { SbBlokData, storyblokEditable } from "@storyblok/js";

import { getCollectionCards } from "@/lib/storyblok/storyblokServerFunctions";
import StoryblokComponent from "@/lib/storyblok/storyblokSetup/StoryblokComponent/StoryblokComponent";
import { StoryblokStory } from "storyblok-generate-ts";
import CollectionCard from "../CollectionCard/CollectionCard";
import styles from "./collection.module.css";

const CollectionCards = ({
  collections,
  preview
}: {
  collections?: StoryblokStory<CollectionPageStoryblok>[];
  preview: boolean;
}) =>
  collections?.map((card) =>
    !card ? null : (
      <CollectionCard
        key={card?.uuid}
        preview={preview}
        imageBlok={
          card.content.listingImage?.[0] as
            | MediaStoryblok
            | TaggedImageStoryblok
        }
        sizes={sizes(100, 33)}
        heading={card.content.Title}
        regularTag={card.content.regularTag}
        boldTag={card.content.boldTag}
        slug={card.slug}
        fullslug={card.full_slug}
      />
    )
  );

const CollectionListingPage = ({
  blok,
  data,
  preview
}: {
  blok: CollectionListingPageStoryblok;
  data?: Awaited<ReturnType<typeof getCollectionCards>>;
  preview: boolean;
}) => {
  if (!blok?.collections) return null;

  const ContentBloks = () =>
    blok.content?.map((content) => {
      return (
        <StoryblokComponent
          blok={content}
          key={content._uid}
          preview={preview}
        />
      );
    });

  return (
    <main
      key={blok._uid}
      {...storyblokEditable(blok as SbBlokData)}
      className="collection-listing-page"
    >
      <div className={styles.hero}>
        <h1 className={styles.title}>{blok.title}</h1>
        <p className={styles.description}>{blok.description}</p>
      </div>
      <ContentBloks />
      <div className={styles.grid} data-layout="blok">
        <CollectionCards collections={data} preview={preview} />
      </div>
    </main>
  );
};

export default CollectionListingPage;
